import { reactive, computed } from 'vue';

const state = reactive({
  view: 'overview'
});

export function setOverviewView() {
  state.view = 'overview';
}

export const isOverviewView = computed(() => {
  return state.view === 'overview';
});

export function setCheckoutView() {
  state.view = 'checkout';
}

export const isCheckoutView = computed(() => {
  return state.view === 'checkout';
});

export function setSuccessInvoiceView() {
  state.view = 'success_invoice';
}

export const isSuccessInvoiceView = computed(() => {
  return state.view === 'success_invoice';
});
